export default {
  // GET Requests //

  // Sets billing information as loaded
  billingLoaded(context) {
    context.commit("billingLoaded");
  },
  async getBillingData(context, companyId) {
    const token = context.rootGetters["authData/token"];
    var companyIdentifier =
      companyId || context.rootGetters["userData/companyId"];
    let response;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/billing/retrieve/" +
          companyIdentifier,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var currencySymbol;
    // Determines the currency code
    if (["AUD", "USD"].includes(response.subscription.currency_code)) {
      currencySymbol = "$";
    }

    // Checks if card object exists
    var cardObject = {};
    if (response.card) {
      cardObject = {
        status: response.card.status,
        maskedNumber: response.card.masked_number,
        last4: response.card.last4,
        cardType: response.card.card_type,
        expiryMonth: response.card.expiry_month,
        expiryYear: response.card.expiry_year,
      };
    }

    let billingAddress;
    if (response.customer.billing_address) {
      billingAddress = {
        firstName: response.customer.billing_address.first_name,
        lastName: response.customer.billing_address.last_name,
        emailAddress: response.customer.billing_address.email_address,
        billingPhone: response.customer.billing_address.billing_phone,
        streetAddress: response.customer.billing_address.street_address,
        city: response.customer.billing_address.city,
        state: response.customer.billing_address.state,
        zipcode: response.customer.billing_address.zipcode,
      };
    }

    context.commit("billingData", {
      accountLocked: response.subscription.status == "cancelled" ? true : false,
      unbilledCharges: response.customer.unbilled_charges,
      paymentMethod: response.customer.payment_method,
      taxability: response.customer.taxability,
      nextBillingAt: response.subscription.next_billing_at,
      promotionalCredits: response.customer.promotional_credits,
      billingPeriodUnit: response.subscription.billing_period_unit,
      currencySymbol: currencySymbol,
      currencyCode: response.subscription.currency_code,
      status: response.subscription.status,
      unpaidCharges: {
        dueInvoiceCount: response.subscription.due_invoices_count,
        totalDues: response.subscription.total_dues,
        dueSince: response.subscription.due_since,
      },
      billingAddress: billingAddress,
      storedCard: cardObject,
    });
    context.commit("billingLoaded");

    return 200;
  },
  // Gets all product items from billing provider
  async getProducts(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;
    let countryCode =
      payload.countryCode || context.rootGetters["userData/companyCountryCode"];

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/billing/product-list/" +
          countryCode,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var productList = [];
    response.forEach((item) => {
      if (item.item_type != "plan") {
        productList.push({
          countryCode: countryCode,
          itemId: item.item_id,
          itemName: item.name,
          description: item.description || null,
          externalName: item.external_name,
          currencyCode: item.currency_code,
          taxable: item.is_taxable,
          price: item.price,
          total:
            context.state.currencySymbol +
            parseFloat(item.price / 100).toFixed(2) +
            " " +
            item.currency_code,
          pricingModel: item.pricing_model,
          type: item.item_type,
        });
      }
    });

    context.commit("productData", productList);
    return 200;
  },
  // GET list of invoices and list of invoice items
  async getInvoices(context) {
    const token = context.rootGetters["authData/token"];
    let response;
    var companyId = context.rootGetters["userData/companyId"];
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/billing/retrieve-invoices/" +
          companyId,
        {
          method: "GET",
          mode: "cors",
          headers: { Authorization: "Bearer " + token },
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    for (let i = 0; i < response.length; i++) {
      response[i].due_date = new Date(
        Number(response[i].due_date) * 1000
      ).toLocaleDateString();
      response[i].date = new Date(
        Number(response[i].date) * 1000
      ).toLocaleDateString();
      response[i].total =
        context.state.currencySymbol +
        parseFloat(response[i].total / 100).toFixed(2) +
        " " +
        context.state.currencyCode;
    }
    context.commit("invoiceData", response);
    context.commit("invoicesLoaded");
    return 200;
  },
  // PATCH Requests //

  // PATCH Chargebee's API to update billing address
  async patchBillingAddress(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;
    const companyId = context.rootGetters["userData/companyId"];
    const companyName = context.rootGetters["userData/companyName"];
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/billing/update-billing-address",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            firstName: payload.firstName || null,
            lastName: payload.lastName || null,
            companyName: companyName,
            streetAddress: payload.streetAddress || null,
            city: payload.city || null,
            state: payload.state || null,
            zipcode: payload.zipcode || null,
            billingPhone: payload.billingPhone || null,
            emailAddress: payload.emailAddress || null,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }
    context.commit("updateBillingInformation", {
      firstName: response.first_name,
      lastName: response.last_name,
      emailAddress: response.email_address,
      billingPhone: response.billing_phone,
      streetAddress: response.street_address,
      city: response.city,
      state: response.state,
      zipcode: response.zipcode,
    });
    return 200;
  },
  // POST Requests //

  //POST Update or add a card
  async postUpdateCard(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;
    var companyId = context.rootGetters["userData/companyId"];
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/billing/update-card",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            firstName: payload.firstName,
            lastName: payload.lastName,
            cardNumber: payload.cardNumber,
            expiryMonth: payload.expiryMonth,
            expiryYear: payload.expiryYear,
            cardCVV: payload.ccv,
          }),
        }
      );

      response = await response.json();
    } catch (err) {
      return 500;
    }

    // Checks response is valid card
    if (response.status) {
      context.commit("updateCard", {
        status: response.status,
        maskedNumber: response.masked_number,
        last4: response.last4,
        cardType: response.card_type,
        expiryMonth: response.expiry_month,
        expiryYear: response.expiry_year,
      });
      return 200;
    } else {
      // Bad request
      return 400;
    }
  },
  // POST collect payment on all outstanding invoices
  async postCollectPayment(context) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;
    let httpStatus;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/billing/collect-payment",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({ companyId: companyId }),
        }
      );
      httpStatus = response.status;
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    if (httpStatus !== 200) {
      return { status: httpStatus };
    }

    await context.dispatch("getBillingData", companyId);
    return { status: 200, transaction: response };
  },
  // DELETE Requests //

  // DELETE billing card
  async deleteCard(context) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    try {
      await fetch(
        process.env.VUE_APP_NODE_SERVER + "/billing/remove-card/" + companyId,
        {
          method: "DELETE",
          mode: "cors",
          headers: { Authorization: "Bearer " + token },
        }
      );
    } catch (err) {
      return 500;
    }
    context.commit("deleteCard");
    return 200;
  },
};
